export const userNeedsDob = (user) => !user?.dateOfBirth;
